import ContractDetails from "./ContractDetails-container";

/**
 * Export the top level component ContractDetails-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default ContractDetails;
